export default "__VITE_ASSET__Af4rNi64__"